<template>
  <footer>
    <div class="container">
      <div class="text" v-if="languageLoaded">
        <div class="help">
          <p>{{$t('footer.help.text1')}}</p>
          <p>{{$t('footer.help.text2')}}</p>
          <p v-html="$t('footer.help.text3')"></p>
        </div>
        <p class="text2">
          <span v-html="$t('footer.text2.part1')"></span>
          <span v-if="showMoreInfo" v-html="$t('footer.text2.part2', { privacyPolicyUrl })"></span>
          &nbsp;
          <span>
            <button
              ref="moreButton"
              @keydown.space.prevent
              @keyup.space="handleContent"
              @click.prevent="showMoreInfo = true"
              v-if="!showMoreInfo"
              :title="$t('footer.linkShowMoreTitle')"
              tabindex="0"
            >{{ $t('footer.linkShowMoreText') }}
            </button>
            <button
              ref="lessButton"
              autofocus
              @keydown.space.prevent
              @keyup.space="handleContent"
              @click.prevent="showMoreInfo = false"
              v-if="showMoreInfo"
              :title="$t('footer.linkShowLessTitle')"
              tabindex="0"
            >{{ $t('footer.linkShowLessText') }}
            </button>
          </span>
        </p>
      </div>
      <p class="copy">
        <span>© Autopay 1999 - {{ currentYear }}</span>
      </p>
    </div>
  </footer>
</template>

<script setup>
import { computed, onBeforeUnmount, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { DateClass } from '@/base/class/date.class'
import { PaymentClass } from '@/base/class/payment.class'
import { emitter } from '@/base/event-bus'
import i18n from '@/base/i18n'

const store = useStore()

const showMoreInfo = ref(false)
const languageLoaded = ref(false)
const moreButton = ref(null)
const lessButton = ref(null)

const lang = computed(() => store.getters.getCurrentLanguage)
const currentYear = DateClass.getCurrentYear()
const privacyPolicyUrl = computed(() => PaymentClass.getPrivacyPolicyLinkByLang(lang.value))

function handleContent () {
  showMoreInfo.value = !showMoreInfo.value
}

watch(showMoreInfo, (value, oldValue) => {
  if (value !== oldValue) {
    if (showMoreInfo.value) {
      setTimeout(() => {
        lessButton.value.focus()
      }, 100)
    }
    if (!showMoreInfo.value) {
      setTimeout(() => {
        moreButton.value.focus()
      }, 100)
    }
  }
})

if (i18n.global.messages?.[i18n.global.locale]) {
  languageLoaded.value = true
}

function languageLoadedHandler () {
  languageLoaded.value = true
}
emitter.on('language-loaded', languageLoadedHandler)

onBeforeUnmount(() => {
  emitter.off('language-loaded', languageLoadedHandler)
})
</script>
